import { get } from 'lodash';

/**
 * Get min & max values of the specified scale.
 *
 * @param {Object}  customisations  customisations object
 * @param {String}  scale           scale name
 * @param {Boolean} logScale        whether log scale is enabled
 * @returns {Object} an object contains Vega scale min/max value related properties
 *                   { domainMin, domainMax, clamp, nice }
 */
export function getScaleMinMaxProps(customisations, scale, logScale) {
  const scaleMin = get(customisations.axes, `${scale}.scaleMin`, {});
  const scaleMax = get(customisations.axes, `${scale}.scaleMax`, {});
  const hasMin = scaleMin.enabled && scaleMin.value;
  const hasMax = scaleMax.enabled && scaleMax.value;
  return {
    nice: !(hasMin || hasMax),
    clamp: !!(hasMin || hasMax),
    domainMax: hasMax ? +scaleMax.value : undefined,
    // eslint-disable-next-line no-nested-ternary
    domainMin: hasMin ? +scaleMin.value : logScale ? 1 : undefined,
  };
}
